/** DjiniousEngineering — the AI systems engineer behind engineering.djinious.com. */
export const BRAND = "DjiniousEngineering";
/**
 * The descriptor says what the product IS, so the wordmark alone answers it.
 * The short form exists because the full one is wider and would push the header
 * into a horizontal scroll on a phone — see Nav.tsx.
 */
export const WORDMARK_SUB = "Systems Engineering · System Ledger · ISO 15288";
export const WORDMARK_SUB_SHORT = "Systems Engineering";

export const NAV_LINKS: { label: string; to: string }[] = [
  { label: "Platform", to: "/platform" },
  { label: "System Ledger", to: "/system-ledger" },
  { label: "Use cases", to: "/use-cases" },
  { label: "AI & autonomy", to: "/ai" },
  { label: "Enterprise", to: "/enterprise" },
  { label: "Pricing", to: "/pricing" },
];

export const FOOTER_TAGLINE =
  "Frame the need, model the system, prove it against evidence, release the data package. One traced thread, gated by a human.";

/**
 * The four beats of the engineering loop. These are the page's structural spine: the
 * rail in the left margin, the section markers, and the order of the argument all come
 * from here. They are an honest grouping of the platform's eleven ISO/IEC/IEEE 15288
 * lifecycle stages — not invented chapter numbers.
 */
export const LOOP_STAGES = [
  { id: "frame", label: "Frame", note: "Mission → requirements" },
  { id: "design", label: "Design", note: "Trades → architecture" },
  { id: "prove", label: "Prove", note: "Models → evidence" },
  { id: "release", label: "Release", note: "Baseline → TDP" },
] as const;

export type LoopStageId = (typeof LOOP_STAGES)[number]["id"];

/** Where the demo form POSTs. Override with VITE_DEMO_ENDPOINT to swap delivery later. */
export const DEMO_ENDPOINT =
  (import.meta.env.VITE_DEMO_ENDPOINT as string | undefined) ?? "/api/demo-request";
